export function isTicketAgent(username: string): boolean {
  return !username.toLowerCase().includes(process.env.NEXT_PUBLIC_EMAIL_DOMAIN || '@');
}
